<template>
  <div class="joinin-step">
    <div v-for="(item, index) in items" :key="item" class="step-item" :class="{ active: index <= active }">
      <span>{{ index + 1 }}</span><em>{{ item }}</em>
    </div>
  </div>
</template>

<script>
export default {
  props: { active: { type: Number, default: 0 } },
  data () { return { items: ['Agreement', 'Store information', 'Payment', 'Store opening'] } }
}
</script>

<style scoped lang="scss">
.joinin-step{display:flex;padding:1rem .7rem .85rem;background:#fff;border-bottom:1px solid #f0f0f0}
.step-item{flex:1;position:relative;text-align:center;color:#aaa;font-size:.55rem}
.step-item:not(:last-child):after{content:'';position:absolute;left:60%;right:-40%;top:.38rem;height:1px;background:#ddd}
.step-item span{position:relative;z-index:1;display:block;margin:0 auto .35rem;width:.8rem;height:.8rem;line-height:.8rem;border-radius:50%;background:#ddd;color:#fff;font-size:.55rem}
.step-item em{font-style:normal;white-space:nowrap}.step-item.active{color:#ff6a00}.step-item.active span,.step-item.active:not(:last-child):after{background:#ff6a00}
</style>
